export default {
  getMediaCollections(state) {
    return state.mediaCollections;
  },
  getUser: (state) => state.user,
  mediasLikedByUser: (state) => state.mediasLikedByUser,
};
